import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TypedFormGroup } from '@feature/forms/form-model';

@Component({
    selector: 'wai-node-info-dialog',
    templateUrl: './node-info-dialog.component.html',
    styleUrls: ['./node-info-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NodeInfoDialogComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  constructor(public dialogRef: MatDialogRef<NodeInfoDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
